module.exports = __webpack_public_path__ + "img/cmb.f785d0a0.jpg";